import dayjs from "dayjs";
import { getURL } from "@/utils/sign";
import axios from "@/requestConfig/intercept";
import { baseUrl } from "@/requestConfig/baseUrl";
import { useMainStore } from "@/store";
import { apiPrintSetting } from "@/api";
import { PRINT_SETUP } from "./default.config";

const env = import.meta.env;
interface KeyVal {
  [key: string]: any;
}
export enum TYPE {
  MONTH = "month",
  QUARTER = "quarter",
}
export enum FILE_TYPE {
  XLSX = "xlsx",
  PDF = "pdf",
}

/** 会计制度 */
export enum PRO_SET {
  ONE = 80,
  TOW = 88,
  THERE = 72,
  FOUR = 69,
  FIVE = 70,
  SIX = 90,
  SEVEN = 95,
  EIGHT = 96,
}

const proSetArr = [
  [80, 1],
  [88, 2],
  [72, 3],
  [70, 4],
  [90, 5],
  [69, 6],
  [95, 8],
  [96, 9],
  // 82: ,
];
// const proSetArr = {
//   80: "小企业会计准则(2013智能做账)",
//   88: "小企业会计准则(2013)",
//   72: "2007年新会计准则",
//   70: "民间非营利组织",
//   90: "农民专业合作社财务会计制度",
//   69: "小企业会计制度",
//   95: "政府会计制度",
//   96: "村集体经济组织会计制度",
//   82: "事业单位会计制度",
// };
export enum NAMES {
  ZCFZB = "资产负债表",
  LRB = "利润表",
  XJLLB = "现金流量表",
  KMYEB = "科目余额表",
  YSTJB = "应收统计表",
  YFTJB = "应付统计表",
  FYTJB = "费用统计表",
  JYZBK = "经营状况表",
  NSTJB = "纳税统计表",
  SYJSYFPB = "收益及收益分配表",
  YYJYYFPB = "盈余及盈余分配表",
  YSJZJYBDB = "预算结转结余变动表",
  YSSRZCB = "预算收入支出表",
  JZCBDB = "净资产变动表",
  SRFYB = "收入费用表",
  CYQYBDB = "成员权益变动表",
  YWHDB = "业务活动表",

  INCOME = "进项",
  OUTPUT = "销项",

  THREE = "三大报表",

  GZB = "schedule",
}
// 所有者权益变动表  财务概要信息表 urlmonth
// 项目利润表 部门利润表 urlmonth  urlseason

export const monthList = {
  [PRO_SET.ONE]: [NAMES.THREE, NAMES.ZCFZB, NAMES.LRB, NAMES.XJLLB, NAMES.KMYEB, NAMES.YSTJB, NAMES.YFTJB, NAMES.FYTJB, NAMES.JYZBK, NAMES.NSTJB],
  [PRO_SET.TOW]: [NAMES.THREE, NAMES.ZCFZB, NAMES.LRB, NAMES.XJLLB, NAMES.KMYEB, NAMES.YSTJB, NAMES.YFTJB, NAMES.FYTJB, NAMES.JYZBK, NAMES.NSTJB],
  [PRO_SET.THERE]: [NAMES.THREE, NAMES.ZCFZB, NAMES.LRB, NAMES.XJLLB, NAMES.KMYEB, NAMES.YSTJB, NAMES.YFTJB, NAMES.FYTJB, NAMES.JYZBK, NAMES.NSTJB],
  [PRO_SET.FOUR]: [NAMES.THREE, NAMES.ZCFZB, NAMES.LRB, NAMES.XJLLB, NAMES.KMYEB, NAMES.YSTJB, NAMES.YFTJB, NAMES.FYTJB, NAMES.JYZBK, NAMES.NSTJB],
  [PRO_SET.FIVE]: [NAMES.ZCFZB, NAMES.YWHDB, NAMES.XJLLB, NAMES.KMYEB],
  [PRO_SET.SIX]: [NAMES.ZCFZB, NAMES.YYJYYFPB, NAMES.CYQYBDB, NAMES.KMYEB],
  [PRO_SET.SEVEN]: [NAMES.ZCFZB, NAMES.SRFYB, NAMES.JZCBDB, NAMES.XJLLB, NAMES.YSSRZCB, NAMES.YSJZJYBDB, NAMES.KMYEB],
  [PRO_SET.EIGHT]: [NAMES.ZCFZB, NAMES.SYJSYFPB, NAMES.KMYEB],
};
export const quarterList = {
  [PRO_SET.ONE]: [NAMES.THREE, NAMES.LRB, NAMES.XJLLB],
  [PRO_SET.TOW]: [NAMES.THREE, NAMES.LRB, NAMES.XJLLB],
  [PRO_SET.THERE]: [NAMES.THREE, NAMES.LRB, NAMES.XJLLB],
  [PRO_SET.FOUR]: [NAMES.THREE, NAMES.LRB, NAMES.XJLLB],
  [PRO_SET.FIVE]: [NAMES.YWHDB, NAMES.XJLLB],
  [PRO_SET.SIX]: [NAMES.YYJYYFPB],
  [PRO_SET.SEVEN]: [NAMES.XJLLB],
  [PRO_SET.EIGHT]: [],
};

export enum AXIOS_TYPE {
  POST = "post",
  GET = "get",
}

export enum URL_TYPE {
  YEAR = "urlyear",
  MONTH = "urlmonth",
  SEASON = "urlseason",
  END_MONTH = "urlendmonth",
}
export interface LinkParams {
  url: string;
  type?: AXIOS_TYPE;
  params?: KeyVal;
  port?: string;
  format?: KeyVal;
  printType?: number;
  overType?: number; // 推送对应的overType值,如果没有则是接口直接返回url
}
export interface UrlParams {
  port: {
    export: LinkParams | string;
    print: LinkParams | string;
  };
  params?: {
    wefname_url: string;
    tableName?: string;
    InvoiceType?: number;
    type?: URL_TYPE[] | URL_TYPE;
    typeEnd?: URL_TYPE.END_MONTH;
  };
}

export const URL: { [key in NAMES]: UrlParams } = {
  [NAMES.ZCFZB]: {
    port: {
      export: {
        url: "/ReportForm/ExportAssetLiabilityReport",
        overType: 190,
        params: {
          showZero: false,
        },
      },
      print: {
        url: "/ReportForm/PrintAssetLiabilityReport",
        overType: 191,
        printType: 200,
        type: AXIOS_TYPE.POST,
        params: {
          showZero: false,
        },
      },
    },
    params: { wefname_url: "balanceSheet", type: URL_TYPE.MONTH },
  },
  [NAMES.LRB]: {
    port: {
      export: {
        url: "/ReportForm/ProfitsExport",
        overType: 220,
        params: {
          showZero: false,
          isShowCpdBalance: true,
          isShowLCpdBalance: true,
          isShowYtdBalance: true,
        },
      },
      print: {
        url: "/ReportForm/ProfitsPrint",
        type: AXIOS_TYPE.POST,
        overType: 221,
        printType: 260,
        params: {
          showZero: false,
        },
      },
    },
    params: { wefname_url: "profitStatement", type: [URL_TYPE.MONTH, URL_TYPE.SEASON] },
  },
  [NAMES.XJLLB]: {
    port: {
      export: {
        url: "/ReportForm/CashFlowExport",
        overType: 200,
      },
      print: {
        url: "/ReportForm/CashFlowPrint",
        overType: 201,
        printType: 271,
        type: AXIOS_TYPE.POST,
      },
    },
    params: { wefname_url: "statementCashFlow", type: [URL_TYPE.MONTH, URL_TYPE.SEASON] },
  },
  [NAMES.KMYEB]: {
    port: {
      export: {
        url: "/AccountBook/AccountBalanceExport",
        overType: 20,
        type: AXIOS_TYPE.POST,
        format: {
          startPeriod: "YYYY-MM-01",
          endPeriod: "YYYY-MM-01",
        },
        params: {
          AccountLevel: 1,
          ShowAssistAccount: false,
          ShowAccountGroupTotalTag: false,
          BeginFullNumber: "",
          EndFullNumber: "",
          AccountGroup: 0,
          HideBalanceZeroTag: false,
          ShowYearTotalTag: false,
        },
        port: baseUrl.cwForm2,
      },
      print: {
        url: "/AccountBook/AccountBalancePrint",
        overType: 21,
        type: AXIOS_TYPE.POST,
        port: baseUrl.cwForm2,
        format: {
          startPeriod: "YYYY-MM-01",
          endPeriod: "YYYY-MM-01",
        },
        params: {
          AccountLevel: 1,
          ShowAssistAccount: false,
          ShowAccountGroupTotalTag: false,
          BeginFullNumber: "",
          EndFullNumber: "",
          AccountGroup: 0,
          HideBalanceZeroTag: false,
          ShowYearTotalTag: false,
          printSetup: PRINT_SETUP,
          printType: 20,
        },
      },
    },
    params: { wefname_url: "subjectBalance", type: URL_TYPE.MONTH },
  },
  [NAMES.YSTJB]: {
    port: {
      export: {
        url: "/ReportForm/ExportReceivableAccountTables",
        overType: 161,
        type: AXIOS_TYPE.POST,
        params: {
          accType: true,
          month: "{period}",
        },
      },
      print: {
        url: "/ReportForm/PrintReceivableAccountTables",
        overType: 160,
        type: AXIOS_TYPE.POST,
        params: {
          accType: true,
          month: "{period}",
        },
      },
    },
    params: { wefname_url: "bosssurface", tableName: "receivable", type: URL_TYPE.MONTH },
  },
  [NAMES.YFTJB]: {
    port: {
      export: {
        url: "/ReportForm/ExportReceivableAccountTables",
        overType: 161,
        type: AXIOS_TYPE.POST,
        params: {
          accType: false,
          month: "{period}",
        },
      },
      print: {
        url: "/ReportForm/PrintReceivableAccountTables",
        overType: 160,
        type: AXIOS_TYPE.POST,
        params: {
          accType: false,
          month: "{period}",
        },
      },
    },
    params: { wefname_url: "bosssurface", tableName: "coping", type: URL_TYPE.MONTH },
  },
  [NAMES.FYTJB]: {
    port: {
      export: {
        url: "/ReportForm/ExportBusinessStatistics",
        overType: 141,
        params: {
          startMonth: 1,
          endMonth: 11,
        },
      },
      print: {
        url: "/ReportForm/PrintBusinessStatistics",
        overType: 140,
        params: {
          startMonth: 1,
          endMonth: 11,
        },
      },
    },
    params: { wefname_url: "bosssurface", tableName: "cost", type: URL_TYPE.YEAR },
  },
  [NAMES.JYZBK]: {
    port: {
      export: {
        url: "/ReportForm/ExportBusinessStatusTables",
        overType: 151,
      },
      print: {
        url: "/ReportForm/PrintBusinessStatusTables",
        overType: 150,
        params: {
          IsShowLast: false,
        },
      },
    },
    params: { wefname_url: "bosssurface", tableName: "business", type: URL_TYPE.YEAR },
  },
  [NAMES.NSTJB]: {
    port: {
      export: {
        url: "/ReportForm/ExportTaxStatistics",
        overType: 621,
        params: {
          IsShowLast: false,
          startMonth: 1,
          endMonth: 11,
        },
      },
      print: {
        url: "/ReportForm/PrintTaxStatistics?",
        overType: 620,
        params: {
          startMonth: 1,
          endMonth: 11,
        },
      },
    },
    params: { wefname_url: "bosssurface", tableName: "paytaxes", type: URL_TYPE.YEAR },
  },
  [NAMES.SYJSYFPB]: {
    port: {
      export: {
        url: "/ReportForm/ProfitAndDistributionsExport",
        overType: 360,
      },
      print: {
        url: "/ReportForm/ProfitAndDistributionsPrint",
        overType: 361,
      },
    },
    params: { wefname_url: "income", type: URL_TYPE.MONTH },
  },
  [NAMES.YYJYYFPB]: {
    port: {
      export: {
        url: "/ReportForm/BugGetInComePayExport",
        overType: 330,
        params: {
          type: 3,
          isShowZero: true,
        },
      },
      print: {
        url: "/ReportForm/NewBugGetInComePayPrint",
        overType: 331,
        printType: 300,
        type: AXIOS_TYPE.POST,
        params: {
          type: 3,
          isShowZero: true,
          showZero: false,
        },
      },
    },
    params: { wefname_url: "Earnings", type: [URL_TYPE.MONTH, URL_TYPE.SEASON] },
  },
  [NAMES.YSJZJYBDB]: {
    port: {
      export: {
        url: "/ReportForm/BugGetCheckChangeExport",
        overType: 340,
      },
      print: {
        url: "/ReportForm/BugGetCheckChangePrint",
        overType: 341,
      },
    },
    params: { wefname_url: "carryover", type: URL_TYPE.MONTH },
  },
  [NAMES.YSSRZCB]: {
    port: {
      export: {
        url: "/ReportForm/BugGetInComePayExport",
        overType: 330,
        params: {
          type: 1,
          isShowZero: true,
        },
      },
      print: {
        url: "/ReportForm/NewBugGetInComePayPrint",
        overType: 331,
        type: AXIOS_TYPE.POST,
        printType: 300,
        params: {
          type: 1,
          isShowZero: true,
          showZero: false,
        },
      },
    },
    params: { wefname_url: "Budgeted", type: URL_TYPE.MONTH },
  },
  [NAMES.JZCBDB]: {
    port: {
      export: {
        url: "/ReportForm/NetAssetChangeExport",
        overType: 320,
      },
      print: {
        url: "/ReportForm/NetAssetChangePrint",
        overType: 321,
      },
    },
    params: { wefname_url: "Statement", type: URL_TYPE.MONTH },
  },
  [NAMES.SRFYB]: {
    port: {
      export: {
        url: "/ReportForm/BugGetInComePayExport",
        overType: 330,
        params: {
          type: 2,
          isShowZero: true,
        },
      },
      print: {
        url: "/ReportForm/NewBugGetInComePayPrint",
        overType: 331,
        printType: 300,
        type: AXIOS_TYPE.POST,
        params: {
          type: 2,
          isShowZero: true,
          showZero: false,
        },
      },
    },
    params: { wefname_url: "Revenue", type: URL_TYPE.MONTH },
  },
  [NAMES.CYQYBDB]: {
    port: {
      export: {
        url: "/ReportForm/MembersEquityChangesExport",
        overType: 310,
      },
      print: {
        url: "/ReportForm/NewMembersEquityPrint",
        overType: 311,
        printType: 310,
        type: AXIOS_TYPE.POST,
      },
    },
    params: { wefname_url: "Members", type: URL_TYPE.MONTH },
  },
  [NAMES.YWHDB]: {
    port: {
      export: {
        url: "/ReportForm/BusinessActivitiesExport",
        overType: 370,
      },
      print: {
        url: "/ReportForm/BusinessActivitiesPrint",
        overType: 371,
        type: AXIOS_TYPE.POST,
        printType: 371,
        params: {
          tooReview: "",
        },
      },
    },
    params: { wefname_url: "operational", type: [URL_TYPE.MONTH, URL_TYPE.SEASON] },
  },

  [NAMES.INCOME]: {
    port: { export: "", print: "" },
    params: { wefname_url: "InvoiceStatistics", InvoiceType: 1, type: URL_TYPE.MONTH, typeEnd: URL_TYPE.END_MONTH },
  },
  [NAMES.OUTPUT]: {
    port: { export: "", print: "" },
    params: { wefname_url: "InvoiceStatistics", InvoiceType: 2, type: URL_TYPE.MONTH, typeEnd: URL_TYPE.END_MONTH },
  },

  [NAMES.THREE]: {
    port: {
      export: {
        url: "/ReportForm/ReportFileUrl",
        params: {
          month: "{period}",
        },
      },
      print: {
        url: "/ReportForm/ReportPDFUrl",
        params: {
          month: "{period}",
        },
      },
    },
    params: undefined,
  },

  [NAMES.GZB]: {
    port: { export: "", print: "" },
    params: { wefname_url: "schedule", type: URL_TYPE.MONTH },
  },
};

/** 获取列表 */
export const getList = (type: TYPE, id: PRO_SET) => {
  // return Object.values(NAMES);
  const newId = getNewId(id);
  if (type == TYPE.QUARTER) return quarterList[newId] || [];
  else return monthList[newId] || [];
};

export const getNewId = (id: PRO_SET) => proSetArr.find((n) => n.includes(id))?.[0] as PRO_SET;

/**
 * 获取链接地址
 * @param name 名称
 * @param isLatest 是否使用最新账套
 * @param isLatest 是否使用最新账套
 * @returns
 */
export const getUrl = (name: NAMES, isLatest = false, { type = URL_TYPE.MONTH, date = 0, dateEnd = 0 }) => {
  const obj = useMainStore().getParams(isLatest);
  if (!URL[name].params) return false;
  const params = handleParams({ ...URL[name].params }, { type, date, dateEnd });
  console.log(params, name, type);

  const url = `${env.VITE_APP_CW}/${getURL({ ...obj, ...params })}`;
  console.log(url);
  return url;
};

export const handleParams = (params: KeyVal, { type = URL_TYPE.MONTH, date = 0, dateEnd = 0 }) => {
  let t;
  if (Array.isArray(params.type)) {
    t = type;
  } else {
    t = params.type;
  }
  const { year, season, period } = getPeriod(date, t == URL_TYPE.SEASON);
  if (t == URL_TYPE.MONTH) params[t] = `${year}-${period}`;
  else if (t == URL_TYPE.SEASON) params[t] = `${year}-${season}`;
  else if (t == URL_TYPE.YEAR) params[t] = year;
  delete params.type;

  if (params.typeEnd) {
    const { period } = getPeriod(dateEnd);
    params[params.typeEnd] = `${year}-${period}`;
    delete params.typeEnd;
  }

  console.log(params, t);
  return params;
};

/** 获取数据,请求接口 */
export const getPort = async (name: NAMES, { date = 0, type = TYPE.MONTH, fileType = FILE_TYPE.XLSX }) => {
  const obj = await getParams(name, fileType, date);
  const params = { ...(obj.params || {}), ...getPeriod(date, type == TYPE.QUARTER, obj.format) };
  formatValue(params);

  return {
    ...(await request(obj, params)),
    overType: obj.overType,
  };
};

/** 获取参数 */
const getParams = async (name: NAMES, fileType = FILE_TYPE.XLSX, date: number): Promise<LinkParams> => {
  const params = URL[name].port;
  const link = fileType == FILE_TYPE.XLSX ? params.export : params.print;
  console.log(name, link, fileType);

  if (typeof link == "string") return Promise.resolve({ url: link, type: AXIOS_TYPE.GET, params: {} });
  if (link.printType) {
    if (!link.params) link.params = {};
    Object.assign(link.params, { excelFileType: link.printType, printSetup: await apiPrintSetting({ printType: link.printType }, date) });
  }
  return Promise.resolve(link);
};

/** 处理动态值, 会吧对应的{*} 替换成 obj[*]的值 */
const formatValue = (obj: KeyVal) => {
  if (typeof obj == "string") return;
  const del: string[] = [];
  Object.keys(obj).forEach((k) => {
    const val = obj[k];
    if (typeof val == "string") {
      if (/{.*}/g.test(val)) {
        const key = val.substring(1, val.length - 1);
        obj[k] = obj[key];
        if (!del.includes(key)) del.push(key);
      }
    }
  });
  del.forEach((k) => delete obj[k]);
};

/** 请求接口 */
export const request = (obj: LinkParams, params: object) => {
  const { type = AXIOS_TYPE.GET, url, port } = obj;
  console.log(obj, axios, obj.type, port || baseUrl.cwForm);

  return axios[type]((port || baseUrl.cwForm) + url, type == AXIOS_TYPE.POST ? params : { params });
};

export interface GetPeriod {
  year?: string;
  season?: string;
  period?: string;
  yearPeriod?: string;
}

/** 获取期间 */
export const getPeriod = (n: number | string, isQuarter = false, format?: KeyVal): GetPeriod => {
  const date = new Date(n);
  const year = date.getFullYear();
  const period = date.getMonth() + 1;
  const season = Math.ceil(Number(dayjs(+date).format("M")) / 3);
  let data = {};
  if (isQuarter) data = { year, season };
  else data = { year, period, yearPeriod: `${year}${period < 10 ? "0" : ""}${period}` };
  if (format) data = getFormat(data, format);
  return data;
};

export const getFormat = (obj: { year?: any; season?: any; period?: any }, format: KeyVal) => {
  let date = new Date();
  date.setFullYear(obj.year);
  if (obj.season) date.setMonth((obj.season - 1) * 3);
  if (obj.period) date.setMonth(obj.period - 1);
  let o: any = {};
  Object.keys(format).forEach((k, i) => {
    if (obj.season && i == 1) o[k] = dayjs(+date).add(3, "month").format(format[k]);
    else o[k] = dayjs(+date).format(format[k]);
  });
  console.log(o);

  return o;
};
